import * as filterHeaderTypes from '../../webcommon/header/filterheader/propTypes';
import { lastWorkingDay } from '../../common/helpermethods/HelperMethods';

export const dailyBatchHistColumns = [
    // {   
    //     Header: 'Run Id',
    //     id : 'runId'
    // },
    {   
        Header: 'Business Date',
        id : 'runDate'
    },
    {   
        Header: 'Start Time',
        id : 'formattedStartTime'
    },
    {   
        Header: 'End Time',
        id : 'formattedEndTime'
    },
    // {   
    //     Header: 'Timestamp',
    //     id : 'formattedTimestamp'
    // },
    {
        Header: 'Status',
        id: 'status'
    },
    {
        Header: 'Message',
        id: 'errorMessage'
    },
    {
        Header: 'Initiated By',
        id: 'initiatedBy'
    },
    {
        Header: 'Timed',
        id: 'timedString'
    }
    //secMode
]

export const filterDefinitions = [
   {
       id: 'businessDate',
       title: 'Date',
       type: filterHeaderTypes.filterTypes.date,
       defaultValue: { from: lastWorkingDay(), to: lastWorkingDay(), today: false },
       availableValues: undefined,
       availableValuesLocation: undefined,
       server: true,
       useValidation: true,
       hideAllButton: true,
       hideToday: true
   }
]
export const defaultFilters = [
   {
       value: {
           from: lastWorkingDay(),
           to: lastWorkingDay(),
           today: false
       },
       definition: filterDefinitions.find(def => def.id === 'businessDate')
   }
]